/**
 * @description gestion de la hauteur de l'image
 */

(() => {
	// FUNCTION
	const h3Gestion = () => {
		document
			.querySelectorAll('div.actualites__result__item')
			.forEach((tuiles) => {
				tuiles
					.querySelectorAll('.rt__grid__result:nth-child(1n) h3')
					.forEach((h3) => {
						if (h3.offsetHeight >= 65) {
							tuiles.querySelectorAll('img').forEach((img) => {
								img.setAttribute(
									'style',
									'height:140px; max-height:140px;'
								);
							});
						}
					});
			});
	};

	// GO 🚀
	const init = () => {
		h3Gestion();
		window.addEventListener('resize', () => {
			h3Gestion();
		});
	};

	init();
})();
